import React from "react";
import {
  CircularProgressbarWithChildren,
  buildStyles,
} from "react-circular-progressbar";
import RadialSeparators from "components/shared/RadialSeprators";
import "react-circular-progressbar/dist/styles.css";
import { Typography } from "@mui/material";

function BareIndicator({
  bareNumber,
  totalBares,
  currentTime,
  startTime,
  endTime,
  sepratorColor,
  size,
  defaultTempo,
  repeat,
  ...rest
}) {
  const value = ((currentTime - startTime) / (endTime - startTime)) * 100;
  const sepratorCount = Math.round(((endTime - startTime) * defaultTempo) / 60 / 8);
  const colorValue = 150 + (bareNumber * 100) / totalBares;

  const activeNumberStyles = {
    marginTop: "10%",
    fontFamily: "bareIndicator",
    fontSize: size,
    color: "#005500",
    animation:
      currentTime < endTime &&
      currentTime >= startTime &&
      "glow 1s ease-in-out infinite alternate",
    textShadow:
      currentTime > endTime
        ? "0 0 2px #fff, 0 0 4px #00aa00, 0 0 4px #00aa00, 0 0 4px #00aa00, 0 0 4px #00aa00, 0 0 4px #00aa00"
        : currentTime < startTime
        ? "0 0 2px #fff, 0 0 4px #aaaa00, 0 0 4px #aaaa00, 0 0 4px #aaaa00, 0 0 4px #aaaa00, 0 0 4px #aaaa00"
        : "0 0 2px #fff, 0 0 4px #00aa00, 0 0 4px #00aa00, 0 0 4px #00aa00, 0 0 4px #00aa00, 0 0 4px #00aa00",
    // boxShadow: "inset 0 0 50px #fff,inset 20px 0 80px #f0f, inset -20px 0 80px #0ff, inset 20px 0 300px #f0f,  inset -20px 0 300px #0ff, 0 0 50px #fff,-10px 0 80px #f0f,10px 0 80px #0ff;",
  };
  const disableadNumberStyles = {
    marginTop: "10%",
    fontFamily: "bareIndicator",
    fontSize: size,
    color: "#333333",
  };
  return (
    <CircularProgressbarWithChildren
      value={repeat > 0 ? value : 0}
      strokeWidth={5}
      styles={buildStyles({
        strokeLinecap: "butt",
        trailColor: "#d6d6d622",
        pathColor: `rgb(0,${colorValue},0)`,
        rotation: 0.5,
        path: {
          strokeDasharray: "0 1",
        },
      })}
    >
      <RadialSeparators
        count={sepratorCount}
        style={{
          strokeLinecap: "butt",
          background: sepratorColor,
          width: "2px",
          // This needs to be equal to props.strokeWidth
          height: `${5}%`,
        }}
      />

      <Typography
        style={repeat > 0 ? activeNumberStyles : disableadNumberStyles}
      >
        {bareNumber}
      </Typography>
    </CircularProgressbarWithChildren>
  );
}

export default BareIndicator;
